<script>
import PopUp from '@/components/PopUp.vue'
import List from '@/components/List/List.vue'
import Form from '@/components/Form/Form.vue'
import UploadPictures from '@/components/UploadPictures.vue'
import YesNoPopUp from '@/components/YesNoPopUp.vue';
import message from '@/helpers/message'
import ToAdmin from '@/components/ToAdmin.vue'
import config from "@/helpers/config"
import Switch from '@/components/Form/Switch.vue'
import UserInstruction from '@/components/UserInstruction.vue'
export default {
    components:{ PopUp, UploadPictures, ToAdmin, Switch, UserInstruction, List, Form, YesNoPopUp },
    created() {  
        if(this.user.user_level != 'SamfallifyCrew' && this.user.user_level != 'Redaktör')
        {
            this.$router.push('/login');
        } 
        this.getPublicPage();
        
        this.$cache.createCache('images', 'images/');
    },
    data() {
        return {             
            showUploadImagesPopUp: false,
            highlightedImage: null,
            height: $(window).height() - 130,
            publicPage: null,
            editImage: null,
            deleteImage: null,
            isLoading: true,
            showDetailedList: false,
            columns: [                             
                { name: 'id', displayName: '<i class="fa-solid fa-eye color-black"></i>', icon: 'fa-solid fa-eye', title: 'Visa bilden', align:'center', function: this.highlightImage, width: 25, hideFilter: true, hideIfEdit: true},
                { name: 'edit', displayName: '<i class="fa-solid fa-pencil color-black"></i>', icon: 'fa-solid fa-pencil', title: 'Redigera bildinformation', align:'center', function: this.edit, width: 25, hideFilter: true, hideIfEdit: true},
                { name: 'delete', displayName: '<i class="fa-solid fa-trash color-black"></i>', title: 'Ta bort bilden', isDelete: true, align:'center', width: 25, hideFilter: true, hideIfEdit: true},                
                { name: 'name', displayName: 'Namn', width: 400, hideFilter: false},      
                { name: 'include_in_image_gallery', displayName: '<i class="fa-solid fa-images color-black"></a>', align:'center', isBoolean: true, width: 30, hideFilter: true, title: 'Visas i bildgalleriet'},              
                { name: 'uploaded_date', displayName: 'Uppladdad', width: 120, hideFilter: false},      
                { name: 'uploaded_by', displayName: 'Uppladdad av', width: 200, hideFilter: false},      
                { name: 'photographer', displayName: 'Fotograf', width: 200, hideFilter: false},      
                { name: 'photo_taken_formatted', displayName: 'Bilden tagen', width: 200, hideFilter: false},      
                { name: 'comments', displayName: 'Kommentar', width: 500, hideFilter: false},      
            ],
            sorting: [
                { name: 'name', displayName: 'Namm' },           
                { name: 'created_date', displayName: 'Uppladdad' },           
                { name: 'uploaded_by', displayName: 'Uppladdad av' },           
            ],
            form: [                   
                    { sections: [                          
                            { sectionName: 'Information om bilden', classes: "g-100", inputs: [ 
                                { type: 'text', prop: 'photographer', title: 'Fotograf', classes: "g-100" },
                                { type: 'date', prop: 'photo_taken', title: 'Datum bilden togs', classes: "g-100" },
                                { type: 'textArea', prop: 'comments', title: 'Kommentarer', classes: "g-100" },
                                { type: 'switch', prop: 'include_in_image_gallery', title: 'Visa i bildgalleriet', classes: "g-50" }                             
                                ]
                            },                       
                        ]
                    }                  
            ],
        }
    },   
    methods:
    {
        edit(image) {
            this.editImage = image;
        },
        download(item)
        {
            window.open(this.url + 'uploads/'+this.customer.id+'/'+ item.name);
        },
        add()
        {
            this.showUploadImagesPopUp = true;
        },
        highlightImage(item) {
            this.highlightedImage = item;
        },
        getPublicPage()
        {
            var self = this;
            this.$communicator.get('admin-public-page/')
                .then(function(data)
                {                 
                    self.publicPage = data.public_page;
                    self.isLoading = false;
                })
                .fail(function(error) {                  
                })  
        },     
        removeImage(id)
        {          
            var self = this;
            this.$communicator.post('images/' + id + '/delete')
                .then(function(data)
                {                 
                    self.getImages();
                    message.setSuccessMessage();
                })
                .fail(function(error) {     
                    switch(error.responseJSON.detail)
                    {
                        case 'part_of_public_page':
                            message.setInfoMessage('Bilden används på den publika sidan. Gå igenom den publika sidan och se till att inga sidor använder bilden innan du försöker igen.');            
                            break;
                        case 'image_used_in_quill':
                            message.setInfoMessage('Bilden används i aktuellt. Gå igenom inläggen i aktuellt och ta bort det innan du tar bort bilden.');            
                            break;                       
                        case 'image_used_in_bookingItem':
                            message.setInfoMessage('Bilden används i ett bokningsobjekt. Ta bort bilden från bokningen innan du tar bort bilden.');            
                            break;                       
                        }

                        
                    })  
                }, 
        remove() {
            this.removeImage(this.deleteImage.id);
        },
        cancelRemove() {
            this.deleteImage = null;
        },   
        getImages()
        {
            this.showUploadImagesPopUp = false;
            this.deleteImage = null;
            if(this.editImage != null && this.editImage.isAppBg)
            {
                
                message.setInfoMessage('Ladda om sidan för att bakgrunden ska bytas till den nya!');            
            }
            this.editImage = null;
            this.$cache.updateCache('images', 'images/');
        },
        includeInGallery(image, include)
        {
            image.include_in_image_gallery = include;
            var self = this;
            this.$communicator.post('images/include-in-image-gallery/', image )
                .then(function(data)
                {                 
                    self.$cache.updateCache('images', 'images/');
                })
                .fail(function(error) {                  
                })  
        }
    },
    watch:
    {
        images: {
            handler(images){
                
            },
            deep: true
        }
    },
    computed:
    {
        user() {return this.$store.state.user; },
        customer() {return this.$store.state.customer; },
        url() { return config.urlToServer },
        images() {  return this.$store.state.images != null ? this.$store.state.images.map(x => ({ ...x, isAppBg: x.id == this.customer.background_image_id })) : []  }      
    }
}
</script>
<template>
    <div v-fade-in v-if="!isLoading">
        <main class="opacity-admin-bg overflow-auto position-relative">
            <ToAdmin :section="'Bildbanken'"></ToAdmin>          
            <div class="float-right">
                <button id="List-sort-btn" class="btn" @click="add">Ladda upp bilder</button>
                <UserInstruction :page="this.$route.name"></UserInstruction>
            </div>
            <div class="float-right">
                <button class="btn" :class="!showDetailedList ? '' : 'btn-gray'" @click="showDetailedList = false"><i class="fa-regular fa-images"></i> Visa galleri</button>
                <button class="btn" :class="showDetailedList ? '' : 'btn-gray'" @click="showDetailedList = true"><i class="fa-solid fa-list"></i> Visa detaljerad lista</button>
            </div>
            <h2>Bildbanken</h2>
            <div v-show="!showDetailedList">       
                <div v-for="image in images" class="AdminImageVault-img-area">
                    <div class="AdminImageVault-toggle-image-gallery">
                        <i class="fa-solid fa-pen" v-tooltip="'Redigera bildinformation'" @click="edit(image)"></i>&nbsp;
                        <i class="fa-solid fa-trash" v-tooltip="'Ta bort bild'" @click="deleteImage = image"></i>&nbsp;
                        <span>
                            <i class="fa-solid fa-images" v-show="!image.include_in_image_gallery" v-tooltip="'Klicka här för att inkludera den i bildgalleriet'" @click="includeInGallery(image, true)"></i>
                            <i class="fa-solid fa-images" v-show="image.include_in_image_gallery" style="color: greenyellow" v-tooltip="'Visas i bildgalleriet (Klicka här för att ta bort den från galleriet)'" @click="includeInGallery(image, false)"></i>
                        </span>
                    </div>
                    <img :src="url + 'uploads/'+ customer.id+'/images/thumbnails/'+ image.name" @click="highlightedImage = image" />
                    <div class="overflow-auto">
                        
                        <p>
                            Namn: {{ image.name }}<br>
                            Uppladdad: {{ image.uploaded_date }}
                        </p>
                    </div>
                </div>
                <div v-if="images.length == 0">
                    Du har inte laddat upp några bilder ännu
                </div>
            </div>
            <div v-show="showDetailedList">
                <List :items="images" :height="height-170" :columns="columns" :noOfFrozenColumns="3" :deleteFunction="removeImage" :nameOfItems="'bilder'" :sorting="sorting" :backgroundColor="this.$colors.list.backgroundColor" :borderColor="this.$colors.list.borderColor"></List>
            </div>
            <div v-if="showUploadImagesPopUp">
                <PopUp>
                    <UploadPictures></UploadPictures>                     
                    <button class="btn float-right" @click="getImages">Klar</button>
                </PopUp>
            </div>           
            <div v-if="highlightedImage != null">
                <PopUp :width="'95%'" :bgColor="'black'">
                    <div class="AdminImageVault-highlighted-image">
                        <button class="btn" @click="highlightedImage = null">Stäng</button>
                        <img :src="url + 'uploads/'+ customer.id+'/images/'+ highlightedImage.name"  :style="{'max-height': height + 'px'}" />                    
                    </div>
                </PopUp>
            </div>           
        </main>
    </div>
    <div v-if="editImage != null">
        <PopUp>
            <h2>Redigera {{ editImage.name }}</h2>
            <div class="g-50">
                <div style="padding-right:10px">
                <img :src="url + 'uploads/'+ customer.id+'/images/'+ editImage.name"  style="height: 100%; margin-top: 16px;" /> 
                </div>
            </div>
            <div class="g-50">
            <Form :form="form" :item="editImage" :url="'images/edit/'" :getItemFunction="getImages" :inEditMode="true"></Form>
            </div>
        </PopUp>
    </div>
    <div v-if="deleteImage != null">
        <YesNoPopUp :yes="remove" :no="cancelRemove" :text="'Är du säker på att du vill ta bort?'"></YesNoPopUp>       
    </div>
</template>
<style scoped>
    .AdminImageVault-img-area
    {
        float: left;        
        height: 240px;
        background: #dbba73;
        border: 1px solid #dbba73;
        color: white;
        font-size: 11px;
        position: relative;

    }
    .AdminImageVault-toggle-image-gallery
    {
        position: absolute;
        top: 6px;
        right: 10px;
        font-size: 17px;
        color: #ddd;
        cursor: pointer;    
        text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
    }
    
    .AdminImageVault-toggle-image-gallery i
    {       
        color: #ddd;  
    }

    .AdminImageVault-img-area img
    {
        height: 200px;
        cursor: pointer;
    }

    .AdminImageVault-img-area p
    {
        margin: 4px 10px;
        line-height: 15px;
    }

    .AdminImageVault-highlighted-image
    {
        text-align: center;
        position: relative;
    }
    .AdminImageVault-highlighted-image img
    {
        max-width: 100%;
    }
    .AdminImageVault-highlighted-image button
    {
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .AdminImageValue-trash
    {
        float: right;
        font-size: 20px;
        padding:5px 10px;
    }
</style>